module.exports = __webpack_public_path__ + "img/IT0000388330750.2fc6fc38.png";